import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import { ThemeProvider } from '@mui/material/styles';
import type { PropsWithChildren } from 'react';

import createBDTheme from '../BDTheme.styles';

const ThemeWrapper = ({ children }: PropsWithChildren): JSX.Element => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={createBDTheme()}>{children}</ThemeProvider>
  </StyledEngineProvider>
);

export default ThemeWrapper;
